<template>
  <div
    :class="{
      'd-flex': type !== 'commissioners',
      'flex-column': type !== 'commissioners',
      'align-items-center': type !== 'commissioners',
      'col': type === 'commissioners'
    }"
  >
    <div class="d-flex justify-content-center">
      <img :src="data.imageSrc" :alt="data.name" />
    </div>
    <p class="avatar-name">{{ data.name }}</p>
    <p class="avatar-position">{{ data.position }}</p>
  </div>
</template>

<script>
export default {
  name: "CardAvatarImage",
  props: {
    data: Object,
    type: String,
  },
};
</script>

<style scoped>
.avatar-name {
  color: white;
  font-size: 24px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 0;
  margin-top: 1rem;
}
.avatar-position {
  color: #d8ad50;
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/cardAvatarImage.vue